<template>
  <div class="w-100 ">
    <b-card title="Ask your queries here!" style="  position: relative;">

      <b-card-text>
        <div style=" max-height: calc(80vh - 200px) !important; overflow: scroll;" ref="messageListRef">
          <!-- v-if="messagesList.length === 0" -->
          <div v-if="messagesList.length === 0" class="d-flex flex-column  justify-content-center align-items-center"
            style="height:50vh">
            <svg width="100" height="100" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_53_37665)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.83333 0.75C8.83333 0.335786 8.49755 0 8.08333 0C7.66912 0 7.33333 0.335786 7.33333 0.75V1.91667C7.33333 1.94483 7.33489 1.97264 7.33791 2H4.66667C3.19391 2 2 3.19391 2 4.66667V10C2 11.4728 3.19391 12.6667 4.66667 12.6667H5.96383C6.1937 12.6667 6.40734 12.7851 6.52917 12.98L7.43467 14.4288C7.69578 14.8466 8.30422 14.8466 8.56533 14.4288L9.47083 12.98C9.59266 12.7851 9.8063 12.6667 10.0362 12.6667H11.3333C12.8061 12.6667 14 11.4728 14 10V4.66667C14 3.19391 12.8061 2 11.3333 2H8.82876C8.83178 1.97264 8.83333 1.94483 8.83333 1.91667V0.75ZM12.5 10V9.33333L3.5 9.33333V10C3.5 10.6443 4.02233 11.1667 4.66667 11.1667H5.96383C6.71088 11.1667 7.40523 11.5515 7.80116 12.185L8 12.5031L8.19884 12.185C8.59477 11.5515 9.28912 11.1667 10.0362 11.1667H11.3333C11.9777 11.1667 12.5 10.6443 12.5 10ZM12.5 4.66667V7.83333L3.5 7.83333V4.66667C3.5 4.02234 4.02234 3.5 4.66667 3.5H11.3333C11.9777 3.5 12.5 4.02234 12.5 4.66667ZM6.66667 5.66667C6.66667 6.21895 6.21895 6.66667 5.66667 6.66667C5.11438 6.66667 4.66667 6.21895 4.66667 5.66667C4.66667 5.11438 5.11438 4.66667 5.66667 4.66667C6.21895 4.66667 6.66667 5.11438 6.66667 5.66667ZM10.3333 6.66667C10.8856 6.66667 11.3333 6.21895 11.3333 5.66667C11.3333 5.11438 10.8856 4.66667 10.3333 4.66667C9.78105 4.66667 9.33333 5.11438 9.33333 5.66667C9.33333 6.21895 9.78105 6.66667 10.3333 6.66667ZM0.75 4C1.16421 4 1.5 4.33579 1.5 4.75L1.5 7.91667C1.5 8.33088 1.16421 8.66667 0.75 8.66667C0.335787 8.66667 0 8.33088 0 7.91667V4.75C0 4.33579 0.335786 4 0.75 4ZM16.1667 4.75C16.1667 4.33579 15.8309 4 15.4167 4C15.0025 4 14.6667 4.33579 14.6667 4.75V7.91667C14.6667 8.33088 15.0025 8.66667 15.4167 8.66667C15.8309 8.66667 16.1667 8.33088 16.1667 7.91667V4.75Z"
                  fill="#98A2B3" />
              </g>
              <defs>
                <clipPath id="clip0_53_37665">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <p class="text-muted font-weight-bold mt-3">Start by asking a new question</p>
          </div>
          <div v-else-if="loadingMessages" class="d-flex flex-column  justify-content-center align-items-center"
            style="height:50vh">
            <b-spinner label="Loading Messages" v-if="loadingMessages"></b-spinner>
            <p class="text-muted font-weight-bold mt-3">Loading previous queries</p>
          </div>
          <div class="mr-3" v-else v-for="(message, index) in messagesList" :key="message.id">
            <div class="mb-2 message-callout-1">
              <small class="text-monospace float-right"> {{ createdAtDate(message.createdAt) }}</small>
              <b-media class="mb-3">
                <template #aside>
                  <b-avatar variant="primary" :text="message.userId[0]"></b-avatar>
                </template>

                <p class="mb-0 ">
                  {{ message.question }}
                </p>
              </b-media>
              <b-media class="mr-5 message-callout-2">
                <template #aside>
                  <b-avatar class="" style="background-color: white;"><img src="@/assets/images/logo.png"
                      height="24px" /></b-avatar>
                </template>

                <p class="mb-0">
                  {{ message.answer }}
                </p>

                <p class="mt-1 font-weight-bold">Related sources:</p>
                <ol class="ml-3">
                  <li v-for="source in message.sources"><a :href="source" target="_blank"
                      class="text-body user-select-all text-primary">{{ source
                      }}</a></li>
                </ol>
              </b-media>
              <b-form @submit.stop.prevent="feedbackChanged(message)" :data-vv-scope="message.id + '-feedback-form'">
                <div class="mt-5 d-flex align-items-end">
                  <p class="mb-0 font-weight-bold mr-3">
                    Is this helpful?
                  </p>
                  <b-form-group class="mb-0">

                    <b-form-radio-group :key="message.id + message.feedbackHelpful" v-model="message.feedbackHelpful"
                      :options="feedbackOptions" name="feedback" v-validate="'required'">
                    </b-form-radio-group>
                    <span class="error text-danger small" v-if="errors.has('feedback')">
                      {{ errors.first("feedback") }}
                    </span>
                  </b-form-group>
                </div>

                <template v-if="message.feedbackHelpful">
                  <div class="mt-1 d-flex align-items-end">
                    <p class="mb-0 font-weight-bold mr-3">
                      How would you rate the quality of this response?
                    </p>
                    <b-form-group class="mb-0">
                      <b-form-radio-group :key="message.id + message.feedbackQuality" v-model="message.feedbackQuality"
                        :options="feedbackQuality" name="feedback-quality" v-validate="'required'"></b-form-radio-group>
                    </b-form-group>
                    <span class="error text-danger small" v-if="errors.has('feedback-quality')">
                      {{ errors.first("feedback-quality") }}
                    </span>
                  </div>
                </template>
                <b-button @click="feedbackChanged(message)" variant="outline-primary" size="sm" class="mt-3"
                  :disabled="message.feedbackSubmitted">Submit
                  Feedback</b-button>
              </b-form>
            </div>
          </div>
        </div>
      </b-card-text>

      <template #footer>
        <b-form class="d-flex justify-content-between" @submit.stop.prevent="sendQuery">
          <b-form-group class="flex-fill">
            <b-form-textarea id="question-input" v-model="queryText" placeholder="Enter your question here" rows="3"
              :disabled="messagesList.length > 0 ? !messagesList[messagesList.length - 1].feedbackSubmitted : false">
            </b-form-textarea>
          </b-form-group>
          <b-form-group>
            <b-button class="ml-3" variant="success" @click="sendQuery" :disabled="sending" type="submit">
              <b-spinner label="Sending" v-if="sending"></b-spinner>
              <i v-else class="fa fa-paper-plane action-icon"></i> Send</b-button>
          </b-form-group>
        </b-form>
      </template>
    </b-card>
  </div>
</template>

<script>
import SupportAIService, { SupportMessagesList } from "@/services/SupportAiService";
import store from "@/store/index";
import * as moment from 'moment'

export default {
  name: 'Support-AI-Chat',
  components: {
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      queryText: "",
      messagesList: [],
      sending: false,
      loadingMessages: false,
      selectedFeeback: undefined,
      selectedQuality: undefined,
      feedbackOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      feedbackQuality: [
        { text: "Not Usable", value: "not-usuable" },
        { text: "Made Minor Adjustments, Usable.", value: "usuable" },
        { text: "Perfect! I copied and pasted it to the client!", value: "perfect" }

      ]
    };
  },

  created() {
    this.$nextTick(async () => {
      await this.fetchMessages();
      this.$refs.messageListRef.scrollTop = this.$refs.messageListRef.scrollHeight

    })
  },
  methods: {
    async fetchMessages() {
      this.loadingMessages = true
      const currentUser = this.$store.state?.auth?.user;
      const response = await SupportAIService.fetch(currentUser.email);

      const finalList = response.data.totalQueries.map((item) => {
        item.feedbackSubmitted = typeof item.feedbackHelpful !== 'undefined' ? true : false
        return item
      })
      this.$set(this, 'messagesList', finalList.reverse())
      this.loadingMessages = false
    },
    createdAtDate(createdAt) {
      let TODAY = moment(new Date()).clone().startOf('day')
      if (moment(createdAt).isBefore(TODAY, 'd')) {
        return moment(createdAt).format('MMM DD')
      }
      return moment(createdAt).format('h:mm A')
    },
    async feedbackChanged(message) {

      await this.$validator.validateAll(message.id + '-feedback-form').then(async result => {
        if (!result) {
          return;
        }
        let updatedMessage = { ...message, feedbackHelpful: message.feedbackHelpful }

        if (message.feedbackQuality) {
          updatedMessage.feedbackQuality = message.feedbackQuality
        }

        const currentUser = this.$store.state?.auth?.user;
        const payload = {
          feedbackHelpful: message.feedbackHelpful ? message.feedbackHelpful : false,
          userId: currentUser.email,
        }

        if (message.feedbackQuality) {
          payload.feedbackQuality = message.feedbackQuality
        }

        try {
          const response = await SupportAIService.update(payload, message.id);

          if (response.data.success) {
            let index = this.messagesList.findIndex((element) => element.id === message.id)
            this.messagesList.splice(index, 1, { ...updatedMessage, feedbackSubmitted: true })

            console.log(this.messagesList[index])

            this.$bvToast.toast('Feedback Submitted successfully!!', {
              title: 'Feedback Submitted',
              autoHideDelay: 1000,
              appendToast: false
            })
          } else {
            console.log(response)
          }
        } catch (err) {
          console.log(err)
          if (err.response && err.response.status === 401) {
            try {
              await store.dispatch("auth/logout");
            } catch (err) { }
            router.push({ name: "login" });
          }
        }


      })
    },

    async sendQuery() {
      if (this.queryText.length <= 0) return;

      this.sending = true;

      try {
        const currentUser = this.$store.state?.auth?.user;

        let payload = {
          question: this.queryText,
          userId: currentUser.email
        };
        const response = await SupportAIService.post(payload);

        console.log(response)
        if (response && response.status === 401) {

          await store.dispatch("auth/logout")
          this.$router.push({ name: "login" });
        } else {
          let item = { ...response.data, feedbackSubmitted: false }

          this.messagesList.push(item);

          this.sending = false;
          this.queryText = ''
          this.$refs.messageListRef.scrollTop = this.$refs.messageListRef.scrollHeight
        }
      } catch (err) {
        console.log(err)
        if (err.response && err.response.status === 401) {
          try {
            await store.dispatch("auth/logout");
          } catch (err) { }
          this.$router.push({ name: "login" });
        }
      }
    }
  },
};
</script>
<style lang="scss">
.message-callout-1 {
  padding: 20px;
  background-color: #f7f7f7;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  color: #333;
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 20px;
}

.message-callout-2 {}
</style>
